import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useMeta from '../hooks/useMeta';
import useAuth from '../hooks/useAuth';
import DashboardSummary from '../components/dashboard/DashboardSummary';

const Chip = ({ to, icon, value, label, loading }) => (
  <Link
    to={to}
    className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:border-brand/40 hover:text-brand transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
  >
    <span className="material-symbols-outlined text-[16px] text-brand" aria-hidden="true">{icon}</span>
    {loading ? (
      <span className="animate-pulse inline-block h-3 w-6 rounded bg-slate-200" aria-hidden="true" />
    ) : (
      value !== '' && <strong className="font-mono font-semibold text-on-surface tabular-nums">{value}</strong>
    )}
    <span>{label}</span>
  </Link>
);

const Dashboard = () => {
  const { user } = useAuth();
  const { accounts, loading, error, fetchAccounts, fetchLeadsStats } = useMeta();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchAccounts().catch(() => {});
    fetchLeadsStats().then(data => setStats(data)).catch(() => {});
  }, []);

  const activeAccounts = accounts.filter(
    (a) => a.account_status === 1 || a.status === 'ACTIVE'
  );

  return (
    <div className="animate-fade-in pb-16 max-w-[1440px] mx-auto space-y-8">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-headline font-bold text-3xl tracking-tight text-on-surface mb-1">Resumo da Inteligência</h1>
          <p className="text-sm text-slate-600 font-body">
            Bem-vindo de volta, <span className="font-medium text-on-surface">{user?.username || user?.email || 'Usuário'}</span>
          </p>
        </div>
        <nav aria-label="Atalhos" className="flex flex-wrap items-center gap-2">
          <Chip to="/accounts" icon="account_balance_wallet" value={accounts.length} label="contas" loading={loading && accounts.length === 0} />
          <Chip to="/accounts" icon="campaign" value={activeAccounts.length} label="ativas" loading={loading && accounts.length === 0} />
          <Chip to="/leads" icon="ads_click" value={stats ? Number(stats.total).toLocaleString('pt-BR') : '—'} label="leads" loading={false} />
          <Chip to="/reports" icon="insert_drive_file" value="" label="Relatórios" loading={false} />
        </nav>
      </header>

      {error && (
        <div role="alert" className="rounded-xl bg-error-container border border-error/20 p-4 flex items-start gap-3">
          <span className="material-symbols-outlined text-error mt-0.5" aria-hidden="true">error</span>
          <div>
            <h4 className="text-sm font-bold text-on-error-container">Meta não conectado</h4>
            <p className="text-sm text-on-error-container/80 font-body">
              Conecte sua conta Meta nas <Link to="/accounts" className="underline font-bold">Contas</Link> para ver dados em tempo real.
            </p>
          </div>
        </div>
      )}

      <DashboardSummary />
    </div>
  );
};

export default Dashboard;
